import { Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpService } from '../../http.service';
import { ConstituencyService } from '../constituency.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-constituency-table',
  templateUrl: './constituency-table.component.html',
  styleUrls: ['./constituency-table.component.scss']
})
export class ConstituencyTableComponent {


  displayedColumns: string[] = ['id', 'name', 'district'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private http: HttpService, public constituencyService: ConstituencyService, private global: GlobalService) {
    this.getConstituency();
    this.constituencyService.downloadConstituency.subscribe((is_update_constituency) => {
      console.log(is_update_constituency);
      if (is_update_constituency) {
        this.getConstituency();
      }
    });
    this.global.set_master_page_title = 'Constituency';
  }

  showConstituencyRegister() {
    this.constituencyService.is_display_constituency_register_component = true;
  }

  hideConstituencyRegister() {
    this.constituencyService.is_display_constituency_register_component = false;
  }

  registerConstituency() {
    this.showConstituencyRegister();
    console.log('register zone');
    this.constituencyService.constituencyUpdate.emit(null);
    this.constituencyService.set_constituency_data = null;
  }

  editConstituency(constituency) {
    this.showConstituencyRegister();
    console.log(constituency);
    this.constituencyService.constituencyUpdate.emit(constituency);
    this.constituencyService.set_constituency_data = constituency;
  }

  getConstituency() {
    this.http.getConstituency().subscribe((data: Constituency[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<Constituency>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

}

export interface Constituency {
  id: number;
  name: string;
}
